import React, { useEffect } from 'react';

function WorkshopModal({ workshop, onClose }) {
  useEffect(() => {
    if (!workshop) return undefined;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [workshop, onClose]);

  if (!workshop) return null;

  const { title, instructor, image, details } = workshop;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label={`Szczegóły warsztatu: ${title}`}
      onMouseDown={onClose}
    >
      <div
        className="bg-white rounded-2xl max-w-3xl w-full overflow-hidden shadow-xl max-h-[90vh] overflow-y-auto"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="grid md:grid-cols-2">
          <div className="aspect-[3/4] md:aspect-auto md:h-full bg-gray-200">
            <img
              src={image}
              alt={`Instruktor: ${instructor}`}
              className="w-full h-full object-cover p-0"
              loading="lazy"
            />
          </div>

          <div className="p-6 text-blue-900">
            <div className="text-center">
              <h3 className="text-2xl font-bold">{title}</h3>
              <p className="text-blue-900/70 mt-1">{instructor}</p>
            </div>

            <div className="mt-4 space-y-3">
              {(details || []).map((p, i) => (
                <p key={i} className="leading-relaxed">
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-6">
              <button
                type="button"
                onClick={onClose}
                className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-gray-100 text-blue-900 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-700"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkshopModal;
